import { ComponentFactoryResolver, ComponentRef, Directive, OnChanges, SimpleChanges, ViewContainerRef } from '@angular/core';
import { AbstractEditorComponent } from './abstract-editor.component';
import { DateEditorComponent } from './date-editor/date-editor.component';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { CountryEditorComponent } from './country-editor/country-editor.component';
import { OperatorEditorComponent } from './operator-editor/operator-editor.component';
import { AirportEditorComponent } from './airport-editor/airport-editor.component';
import { CityEditorComponent } from './city-editor/city-editor.component';
import { CivilityEditorComponent } from './civility-editor/civility-editor.component';
import { PhoneEditorComponent } from './phone-editor/phone-editor.component';
import { BooleanEditorComponent } from './boolean-editor/boolean-editor.component';
import { FormBuilder } from '@angular/forms';
import { ValidatorEditorService } from './validator-editor.service';
import { SelectItem } from "@tj/tj-dmp-lib-api";
import { ProductTypeEditorComponent } from './product-type-editor/product-type-editor.component';
import { CurrentTypeEditorComponent } from './current-type-editor/current-type-editor.component';
import { ProviderEditorComponent } from './provider-editor/provider-editor.component';


const componentMapper = {
    DATE: DateEditorComponent,
    DATE_TIME: DateEditorComponent,
    TEXT: TextEditorComponent,
    NUMBER: TextEditorComponent,
    IATA_CITY: CityEditorComponent,
    IATA_AIRPORT: AirportEditorComponent,
    IATA_COUNTRY: CountryEditorComponent,
    CARRIER: OperatorEditorComponent,
    //
    COUNTRY: CountryEditorComponent,
    CIVILITY: CivilityEditorComponent,
    TIME: DateEditorComponent,
    AFFILIATION: TextEditorComponent,
    LANG: TextEditorComponent,
    EMAIL: TextEditorComponent,
    PRICE: TextEditorComponent,
    PHONE: PhoneEditorComponent,
    BOOKING_REFERENCE: TextEditorComponent,
    PRODUCT_TYPE: ProductTypeEditorComponent,
    CONTACT_TYPE: CurrentTypeEditorComponent,
    BOOLEAN: BooleanEditorComponent,
    // TIME, AFFILIATION, LANG, CIVILITY
    String255: TextEditorComponent,
    String25: TextEditorComponent,
    String3: TextEditorComponent,
    String100: TextEditorComponent,
    String10: TextEditorComponent,
    String50: TextEditorComponent,
    Int: TextEditorComponent,
    BigInt: TextEditorComponent,
    Decimal_5_2: TextEditorComponent,
    Decimal_8_2: TextEditorComponent,
    Decimal_11_2: TextEditorComponent,
    Boolean: BooleanEditorComponent,
    DateTime: DateEditorComponent,
    Date: DateEditorComponent,
    Time: DateEditorComponent,
    UUID: TextEditorComponent
};


@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[dmpDynamicEditorDirective]',
    standalone: false
})
export class DynamicEditorDirective extends AbstractEditorComponent implements OnChanges {

    componentRef: ComponentRef<any>;

    constructor(
        private resolver: ComponentFactoryResolver,
        private container: ViewContainerRef,
        protected fb: FormBuilder,
        protected validatorService: ValidatorEditorService
        // protected elRef:ElementRef,
        // protected renderer: Renderer2,
    ) {
        super(fb, validatorService);
    }
    transformBeforeSave(value: any) {
        return value;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.field && !this.componentRef) {
            this.createComponent();
        }
        if (changes.value && this.componentRef) {
            this.componentRef.instance.value = this.value;
        }
    }

    createComponent() {
        if(this.field){
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }
        if (this.field) {
            if (!this.field.categoryField) {
                this.field.categoryField = 'TEXT';
            }
            let component;
            if (this.field.code === 'provider_name' && !this.importMode) {
                component = ProviderEditorComponent;
            } else if (['TECHNICAL', 'TEXT'].includes(this.field.categoryField)) {
                component = componentMapper[this.field.type];
            } else {
                component = componentMapper[this.field.categoryField];
            }
            if (component === undefined) {
                console.log(this.field.categoryField + ' not found replace by text');
                component = componentMapper.TEXT;
            }
            const factory = this.resolver.resolveComponentFactory(
                component
            );
            this.componentRef = this.container.createComponent(factory);
            this.componentRef.instance.field = this.field;
            this.componentRef.instance.value = this.value;
            this.componentRef.instance.valueChange = this.valueChange;
            this.componentRef.instance.originalValue = this.originalValue;
            this.componentRef.instance.cellEditor = this.cellEditor;
            this.componentRef.instance.displayButton = this.displayButton;
            this.componentRef.instance.onInitReady = this.onInitReady;
            this.componentRef.instance.dataNotFound = this.dataNotFound;
            this.componentRef.instance.importMode = this.importMode;
            //
            if (this.componentRef.instance.ngOnInit) {
                this.componentRef.instance.ngOnInit();
            }
        }
            
        }
    }

    update() {
        if(!this.componentRef){
            this.createComponent();
        } else if(this.componentRef){
            this.componentRef.instance.value = this.value;
        }
    }

}
